import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface timeSlotState {
	isLoading: boolean;
	timeSlotList: any;
	timeSlotDetail: any;
	totaltimeSlote: number;
}

const initialState: timeSlotState = {
	isLoading: false,
	timeSlotDetail: {},
	timeSlotList: [],
	totaltimeSlote: 0
};

const timeSloteSlice = createSlice({
	name: 'timeSlote',
	initialState,
	reducers: {
		getAlltimeSlotListInIt: state => {
			state.isLoading = true;
		},
		getAlltimeSlotListSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			state.isLoading = false;
			state.totaltimeSlote = data.count;
			state.timeSlotList = [...data.timeSlotData];
		},
		getAlltimeSlotListError: state => {
			state.isLoading = false;
			state.timeSlotList = [];
			state.totaltimeSlote = 0;
		},
		deletetimeSlotInit: state => {
			state.isLoading = true;
		},
		deletetimeSlotSuccess: state => {
			// state.isLoading = false;
		},
		deletetimeSlotError: state => {
			state.isLoading = false;
		},
		gettimeSlotByIdInIt: state => {
			state.isLoading = true;
		},
		gettimeSlotByIdSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			state.timeSlotDetail = { ...action.payload.data.timeSlot };
		},
		gettimeSlotByIdError: state => {
			state.isLoading = false;
		},
		cleartimeSlotDetail: state => {
			state.timeSlotDetail = {};
		},
		addtimeslotInIt: state => {
			state.isLoading = true;
		},
		addtimeslotSuccess: state => {
			state.isLoading = false;
		},
		addtimeslotError: state => {
			state.isLoading = false;
		},
		updateTimeSloteStatusInIt: state => {
			state.isLoading = true;
		},
		updateTimeSloteStatusSuccess: state => {
			state.isLoading = false;
		},
		updateTimeSloteStatusError: state => {
			state.isLoading = false;
		}
	}
});

export const {
	getAlltimeSlotListError,
	getAlltimeSlotListInIt,
	getAlltimeSlotListSuccess,
	deletetimeSlotError,
	deletetimeSlotInit,
	deletetimeSlotSuccess,
	gettimeSlotByIdError,
	gettimeSlotByIdInIt,
	gettimeSlotByIdSuccess,
	addtimeslotError,
	addtimeslotInIt,
	addtimeslotSuccess,
	cleartimeSlotDetail,
	updateTimeSloteStatusError,
	updateTimeSloteStatusInIt,
	updateTimeSloteStatusSuccess
} = timeSloteSlice.actions;

export default timeSloteSlice.reducer;
